/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Parameters of the configuration
 * @export
 * @interface GroundingParameters
 */
export interface GroundingParameters {
    /**
     * Check if the vessel is in the same location after VALIDATE_MINUTES have passed
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useInSameLocation?: boolean;
    /**
     * Check if the vessel has stopped, using sog < 1
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useStopCheck?: boolean;
    /**
     * Check if the vessel is in shallow waters, using depth between 0 and -20
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useShallowWaters?: boolean;
    /**
     * Check if the vessel's SOG has greatly decreased in a short period
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useSogDecrease?: boolean;
    /**
     * Consider the vessel's NAV_STAT when checking for groundings
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useNavStat?: boolean;
    /**
     * Minutes to wait before ensuring that a grounding actually took place
     * @type {number}
     * @memberof GroundingParameters
     */
    validateMinutes?: number;
    /**
     * Filter out potential groundings in ports
     * @type {boolean}
     * @memberof GroundingParameters
     */
    filterPorts?: boolean;
    /**
     * Filter out potential groundings in anchorage areas
     * @type {boolean}
     * @memberof GroundingParameters
     */
    filterAnchorageAreas?: boolean;
    /**
     * Check if the vessel remains grounded
     * @type {boolean}
     * @memberof GroundingParameters
     */
    useRemainsGroundedCheck?: boolean;
}

/**
 * Check if a given object implements the GroundingParameters interface.
 */
export function instanceOfGroundingParameters(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GroundingParametersFromJSON(json: any): GroundingParameters {
    return GroundingParametersFromJSONTyped(json, false);
}

export function GroundingParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroundingParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useInSameLocation': !exists(json, 'use_in_same_location') ? undefined : json['use_in_same_location'],
        'useStopCheck': !exists(json, 'use_stop_check') ? undefined : json['use_stop_check'],
        'useShallowWaters': !exists(json, 'use_shallow_waters') ? undefined : json['use_shallow_waters'],
        'useSogDecrease': !exists(json, 'use_sog_decrease') ? undefined : json['use_sog_decrease'],
        'useNavStat': !exists(json, 'use_nav_stat') ? undefined : json['use_nav_stat'],
        'validateMinutes': !exists(json, 'validate_minutes') ? undefined : json['validate_minutes'],
        'filterPorts': !exists(json, 'filter_ports') ? undefined : json['filter_ports'],
        'filterAnchorageAreas': !exists(json, 'filter_anchorage_areas') ? undefined : json['filter_anchorage_areas'],
        'useRemainsGroundedCheck': !exists(json, 'use_remains_grounded_check') ? undefined : json['use_remains_grounded_check'],
    };
}

export function GroundingParametersToJSON(value?: GroundingParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'use_in_same_location': value.useInSameLocation,
        'use_stop_check': value.useStopCheck,
        'use_shallow_waters': value.useShallowWaters,
        'use_sog_decrease': value.useSogDecrease,
        'use_nav_stat': value.useNavStat,
        'validate_minutes': value.validateMinutes,
        'filter_ports': value.filterPorts,
        'filter_anchorage_areas': value.filterAnchorageAreas,
        'use_remains_grounded_check': value.useRemainsGroundedCheck,
    };
}

